import React from 'react';

export default React.createContext({
  theme: "dark",
  toggleTheme: product => {},
});